import { render, staticRenderFns } from "./showVod.vue?vue&type=template&id=577e3d04&"
import script from "./showVod.vue?vue&type=script&lang=js&"
export * from "./showVod.vue?vue&type=script&lang=js&"
import style0 from "./showVod.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports